// extracted by mini-css-extract-plugin
module.exports = {"subfooter":"footer_subfooter__1jBVM","block":"footer_block__3CKcp","logo-footer":"footer_logo-footer__3mtx0"};